import axios from "axios";
import { Buffer } from "buffer";
import { validLinkPattern, validLinkProtocol } from "../RegExpValidations";

export const getBase64FromUrl = async (url) => {
  try {
    const data = await fetch(url);
    const blob = await data.blob();
    return new Promise((resolve) => {
      const reader = new FileReader();
      reader.readAsDataURL(blob);
      reader.onloadend = () => {
        const base64data = reader.result;
        resolve(base64data);
      };
    });
  } catch (err) {
    console.error("Error fetching image:", err);
    return "";
  }
};

export const fileToBase64 = (file) =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = reject;
  });

export const base64ToFile = (dataUrl, filename = "file") => {
  const arr = dataUrl.split(",");
  if (arr.length < 2) {
    return undefined;
  }
  const mimeArr = arr[0].match(/:(.*?);/);
  if (!mimeArr || mimeArr.length < 2) {
    return undefined;
  }
  const mime = mimeArr[1];
  const buff = Buffer.from(arr[1], "base64");
  return new File([buff], filename, { type: mime });
};

export const handleFilesUpdate = async (
  files,
  setFiles,
  dispatch,
  isCheckSize = true
) => {
  if (!files.length) {
    setFiles([]);
    return;
  }
  if (!isCheckSize || window.location.pathname.endsWith("/edit")) {
    setFiles(files);
    return;
  }
  try {
    const { data } = await axios("/entry/file/storage_size");
    if (data.storageSize !== null) {
      let summarySize = files.reduce((ac, file) => (ac += file.fileSize), 0);
      if (summarySize + data.usedStorageSize >= data.storageSize) {
        dispatch();
        setFiles([]);
        return;
      }
      setFiles(files);
    } else {
      setFiles(files);
    }
  } catch (error) {
    console.log(error);
  }
};

export const encodeLinkSpaces = (str) => {
  const [, origin, rest] = str.trim().match(/^((?:[^\s/?#]+:\/\/)?[^/?#]*)([\s\S]*)$/);
  return origin + rest.replace(/\s/g, "%20");
};

export const handleLink = (str, setValidLink, setLink) => {
  let string = encodeLinkSpaces(str);
  if (validLinkPattern.test(string) && string.length <= 255) {
    setValidLink(true);
    if (!/^.+:\/\//.test(string)) {
      string = `http://${string}`;
    }
  } else {
    setValidLink(false);
  }
  setLink(string);
};

export const getUrlExtension = (url) => {
  return url.split(/[#?]/)[0].split(".").pop().trim();
};

export const getFileFromUrl = async (fileUrl, fileName) => {
  const imgExt = getUrlExtension(fileUrl);
  const response = await fetch(fileUrl);
  const blob = await response.blob();
  const file = new File([blob], fileName + "." + imgExt, {
    type: blob.type,
  });
  return file;
};

export const isNoEditRoute =
  !window.location.pathname.endsWith("/edit") || window.location.pathname.includes("/constructor");

export const convertImageToBase64 = async (url) => {
  if (
    url &&
    (url.includes("/qr/logo/") || url.includes("/qr/backgroundImage/"))
  ) {
    const data = await getBase64FromUrl(url);
    return data;
  } else {
    return url;
  }
};

export const lazyRetry = function (componentImport) {
  return new Promise((resolve, reject) => {
    const hasRefreshed = JSON.parse(
      window.sessionStorage.getItem("retry-lazy-refreshed") || "false"
    );

    componentImport()
      .then((component) => {
        window.sessionStorage.setItem("retry-lazy-refreshed", "false");
        resolve(component);
      })
      .catch((error) => {
        if (!hasRefreshed) {
          window.sessionStorage.setItem("retry-lazy-refreshed", "true");
          return window.location.reload();
        }
        reject(error);
      });
  });
};

const loadImage = async (url) => {
  return new Promise((resolve) => {
    const img = new Image();
    img.crossOrigin = "anonymous";
    img.src = url;
    img.onload = () => resolve(img);
    img.onerror = () => resolve(null);
  });
};

export const getBase64PngFromBase64PSvg = async (urlStr) => {
  if (urlStr) {
    const canvas = document.createElement("canvas");
    const ctx = canvas.getContext("2d");
    const img = await loadImage(urlStr);
    if (img === null) {
      canvas.width = 1;
      canvas.height = 1;
      ctx.fillStyle = "#ffffff";
      ctx.fillRect(0, 0, 1, 1);
    } else {
      canvas.width = img.width;
      canvas.height = img.height;
      ctx.drawImage(img, 0, 0);
    }
    return canvas.toDataURL();
  }
  return null;
};



export const getSerializedSVGwithAnyLogo = (serializedSVG) => {
  const regexImgTag = new RegExp(
    `<image\\s+([^>]*\\s)?href=["']?\\s*data:image[^"']*["']?([^>]*)/>`,
    "g"
  );
  const matches = serializedSVG.match(regexImgTag);
  const replacedImage = matches[0].replace("href", "xlink:href");
  return serializedSVG.replace(regexImgTag, replacedImage);
};

export const getCookie = (cookieName) => {
  const cookies = document.cookie.split(";");
  for (let i = 0; i < cookies.length; i++) {
    const cookie = cookies[i].trim();
    if (cookie.startsWith(cookieName + "=")) {
      return decodeURIComponent(cookie.substring(cookieName.length + 1));
    }
  }
  return null;
};

export const isValidLinkString = (str) => {
  const linkStr = str.trim();
  if (linkStr.startsWith("http")) {
    return validLinkPattern.test(linkStr.trim());
  } else {
    return validLinkProtocol.test(linkStr.trim());
  }
};

export function blobToBase64(blob) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(blob);
    reader.onloadend = () => resolve(reader.result);
    reader.onerror = reject;
  });
}

export const parseDMS = (dmsString, type = "lat") => {
  if (!dmsString) return null;

  const num = Number(dmsString);
  if (!isNaN(num)) {
    if (type === "lat" && num >= -90 && num <= 90) return num;
    if (type === "lon" && num >= -180 && num <= 180) return num;
    return null;
  }

  const regex = /(\d+)°(\d+)'([\d.]+)"?\s*([NSEW])/i;
  const match = dmsString.match(regex);
  if (!match) return null;

  const degrees = parseFloat(match[1]);
  const minutes = parseFloat(match[2]);
  const seconds = parseFloat(match[3]);
  const direction = match[4].toUpperCase();

  let decimal = degrees + minutes / 60 + seconds / 3600;
  if (direction === "S" || direction === "W") decimal *= -1;

  if (type === "lat" && decimal >= -90 && decimal <= 90) return decimal;
  if (type === "lon" && decimal >= -180 && decimal <= 180) return decimal;

  return null;
};

export async function convertHeicToJpeg(file) {
  if (!(file instanceof File)) {
    throw new TypeError("Expected a File object");
  }

  const allowedMimeTypes = ["image/heic", "image/heif"];

  const isValidMimeType = allowedMimeTypes.includes(file.type);
  const isValidExtension = /\.hei(c|f)$/i.test(file.name.trim());
  const isValidFile = isValidMimeType || isValidExtension;
  
  if (!isValidFile) {
    throw new TypeError("Expected a HEIC or HEIF file");
  }

  const { default: heicConvert } = await import("heic-convert/browser");
  const buffer = new Uint8Array(await file.arrayBuffer());

  const convertedBlob = await heicConvert({
    buffer,
    format: "JPEG", // output format
    quality: 1, // JPEG quality (0-1)
  });

  const fileNameWithoutExtension = file.name.replace(/\.[^/.]+$/, "");
  const convertedFileName = `${fileNameWithoutExtension}.jpeg`;

  const convertedFile = new File([convertedBlob], convertedFileName, {
    type: "image/jpeg",
    lastModified: Date.now(),
  });

  return convertedFile;
}

// Mirrors a Formik `values` structure, marking every leaf as touched, so all
// validation messages can be rendered at once (e.g. setTouched(deepTouched(values))).
export const deepTouched = (value) => {
  if (Array.isArray(value)) return value.map(deepTouched);
  if (value && typeof value === "object") {
    return Object.keys(value).reduce((acc, key) => {
      acc[key] = deepTouched(value[key]);
      return acc;
    }, {});
  }
  return true;
};